import { SsoProvider, WorkspaceDefaultProjectAccessMode, WorkspaceDefaultProjectRole, WorkspaceIpSettings, WorkspaceProfile, } from "@supernova-studio/model";
import { z } from "zod";
const prohibitedSsoKeys = ["providerId", "metadataXml", "emailDomains"];
export function validateSsoPayload(ssoPayload) {
    const keys = [];
    let valid = true;
    if (!ssoPayload) {
        valid = true;
        return {
            valid,
            keys: [],
        };
    }
    for (const key of Object.keys(ssoPayload)) {
        if (prohibitedSsoKeys.includes(key)) {
            keys.push(key);
            valid = false;
        }
    }
    return {
        valid,
        keys,
    };
}
export const NpmRegistryInput = z.object({
    enabledScopes: z.array(z.string()),
    customRegistryUrl: z.string().optional(),
    bypassProxy: z.boolean().optional(),
    npmProxyRegistryConfigId: z.string().optional(),
    npmProxyVersion: z.number().optional(),
    registryType: z.string(),
    authType: z.string(),
    authHeaderName: z.string(),
    authHeaderValue: z.string(),
    accessToken: z.string(),
    username: z.string(),
    password: z.string(),
});
export const WorkspaceConfigurationPayload = z.object({
    ipWhitelist: WorkspaceIpSettings.partial().optional(),
    sso: SsoProvider.partial().optional(),
    npmRegistrySettings: NpmRegistryInput.partial().optional(),
    profile: WorkspaceProfile.partial().optional(),
    aiFeaturesEnabled: z.boolean().optional(),
    projectsEnabled: z.boolean().optional(),
    defaultProjectAccessMode: WorkspaceDefaultProjectAccessMode.optional(),
    defaultProjectRole: WorkspaceDefaultProjectRole.optional(),
    aiAskFeaturesEnabled: z.boolean().optional(),
    aiCustomInstruction: z.string().optional(),
});
